import { useRouter } from 'next/router'
import { useMemo } from 'react'
import { getTags } from '~map-search/helpers/getTags'

const useTags = () => {
  const { query: { tags } = {} } = useRouter()
  return useMemo(() => getTags({ tags }), [tags])
}

export { useTags }
